// Pure re-arm bookkeeping for SceneTransition's walk-into-the-edge exit zones.
//
// Exit zones are positional and re-checked every frame. When an exit's onTrigger resolves
// false (the player declined the Podwórko unlock modal, or the purchase failed) she is
// still standing INSIDE the zone — input is locked while the modal is up, so she cannot
// step out between frames and the very next frame would re-open the modal forever. The
// saved location is inside the zone too, so a reload resumed straight into the loop.
//
// Rule: a cancelled exit arms "must leave EVERY zone first". Hit detection is skipped
// until she is outside all of this scene's exit zones, then it re-arms by itself.
//
// Kept free of Phaser/config/audio imports so it can be unit-tested with `node --test`.

/** Fresh state for a scene's SceneTransition. */
export function initialExitState() {
  return { triggered: false, rearmAfterLeave: false };
}

/** After a hit: latch so the pending transition can't double-fire. */
export function triggeredState(state) {
  return { ...state, triggered: true };
}

/** After onTrigger() resolved false: un-latch, but don't re-offer until she walks away. */
export function cancelledState(state) {
  return { ...state, triggered: false, rearmAfterLeave: true };
}

/**
 * Clear the "must leave first" latch once the player is outside every exit zone.
 * Returns the same object when nothing changes, so callers can assign unconditionally.
 */
export function nextRearmState(state, insideAnyZone) {
  if (state.rearmAfterLeave && !insideAnyZone) return { ...state, rearmAfterLeave: false };
  return state;
}

/** Should this frame act on an exit-zone hit? */
export function shouldCheckExits(state, insideAnyZone) {
  if (state.triggered) return false;
  if (state.rearmAfterLeave && insideAnyZone) return false;
  return true;
}
